var map = {
	"./affaere1/edit-button-grey.svg": 19094,
	"./affaerentreff/edit-button-grey.svg": 5808,
	"./casualxdates/edit-button-grey.svg": 33461,
	"./edit-button-grey.svg": 70052,
	"./ficktreffpunkt24/edit-button-grey.svg": 15827,
	"./fremdgehboerse/edit-button-grey.svg": 94075,
	"./illicitoasis/edit-button-grey.svg": 64118,
	"./seitensprungtreff69/edit-button-grey.svg": 84238
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 89200;